import { cx } from '@mage-ui/styled-system/css';
import { logoSymbol } from '@mage-ui/styled-system/recipes';

export const LogoSymbol = ({ title, className, viewBox, symbol }) => {
  return (
    <svg className={cx(className, logoSymbol())} viewBox={viewBox}>
      <title>{title}</title>
      <use href={`#${symbol}`} />
    </svg>
  );
};
